export const getExtFile = (fileName) => {
  if (typeof fileName !== 'string') {
    return '';
  }
  const parts = fileName.split('.');

  return parts[parts.length - 1];
};
